export default __webpack_public_path__ + "static/media/gadgets.d8460463.png";